// 配置不同菜单模块页面的文本
const modulePageTextSetting: any = {
  usermanagement_userID: {
    maxLength: 60,
  },
  account_accountName: {
    minLength: 3,
    maxLength: 160,
  },
  account_email: {
    minLength: 7,
    maxLength: 254,
  },
  memberMgr_NewConnection_referenceCode: {
    maxLength: 255,
  },
  memberMgr_changeLanguage_remarks: {
    maxLength: 255,
  },
  memberMgr_changeOffer_remarks: {
    maxLength: 255,
  },
  memberMgr_reactivate_contactEmail: {
    maxLength: 60,
  },
  memberMgr_suspend_contactEmail: {
    maxLength: 60,
  },
  ticketMgr_contactEmail: {
    maxLength: 60,
  },
  menuMgr_directoryName: {
    maxLength: 255,
  },
  menuMangement_menuName: {
    maxLength: 60,
  },
  menuMangement_url: {
    maxLength: 4000,
  },
  menuMangement_privCode: {
    maxLength: 60,
  },
  menuMangement_privElment: {
    maxLength: 4000,
  },
  menuMangement_remarks: {
    maxLength: 120,
  },
  portalMgr_portalName: {
    maxLength: 255,
  },
  portalMgr_portalUrl: {
    maxLength: 255,
  },
  portalMgr_extraUrl: {
    maxLength: 255,
  },
  roleMgr_roleName: {
    maxLength: 60,
  },
  faqConfg_newCategory: {
    maxLength: 255,
    placeholder: 'Maximum length 255',
  },
  faqConfig_keyWords: {
    maxLength: 255,
  },
  systemParam_currentValue: {
    maxLength: 4000,
  },
};

export default {
  ...modulePageTextSetting,
};
